import { getHandler, patchHandler, postHandler } from 'src/utils/fetchHandler';
import { getPendingDonorUpdate } from './donor.selector';
import { getPrimaryFundraiserAssignmentType } from '../fundraiserAssignmentTypes/fundraiserAssignmentType.selector';

import {
	CLEAR_DONORS,
	CLEAR_DONOR_UPDATE_ERRORS,
	GET_DONOR,
	GET_DONORS,
	FETCH_DONOR_FAILED,
	FETCH_DONORS_FAILED,
	FETCH_DONOR_SUCCEEDED,
	FETCH_DONORS_SUCCEEDED,
	UPDATE_DONOR,
	UPDATE_DONOR_FAILED,
	UPDATE_DONOR_SUCCEEDED,
	CREATE_NEW_ASSIGNMENT_REQUESTED,
	CREATE_NEW_ASSIGNMENT_SUCCEEDED,
	CREATE_NEW_ASSIGNMENT_FAILED,
	UPDATE_ASSIGNMENT_REQUESTED,
	UPDATE_ASSIGNMENT_SUCCEEDED,
	UPDATE_ASSIGNMENT_FAILED,
	UPDATE_FILTER,
	SET_SORT_BY,
} from './donor.constant';

export const DONORS_PATH = 'v2/donors';

export const setSortBy = settings => ({
	type: SET_SORT_BY,
	payload: settings,
});

export const clearDonors = () => ({
	type: CLEAR_DONORS,
});

export const clearDonorUpdateErrors = () => ({
	type: CLEAR_DONOR_UPDATE_ERRORS,
});

export const getDonor = () => ({
	type: GET_DONOR,
});

export const getDonors = () => ({
	type: GET_DONORS,
});

export const fetchDonorFailed = payload => ({
	type: FETCH_DONOR_FAILED,
	payload,
});

export const fetchDonorsFailed = payload => ({
	type: FETCH_DONORS_FAILED,
	payload,
});

export const fetchDonorSucceeded = payload => ({
	type: FETCH_DONOR_SUCCEEDED,
	payload,
});

export const fetchDonorsSucceeded = payload => ({
	type: FETCH_DONORS_SUCCEEDED,
	payload,
});

export const fetchDonor = (id, params) => {
	return dispatch => {
		dispatch(getDonor());
		const path = `${DONORS_PATH}/${id}`;

		return getHandler(path, params)
			.then(json => dispatch(fetchDonorSucceeded(json)))
			.catch(error => {
				console.error('fetchDonor error', error);
				dispatch(fetchDonorFailed());
			});
	};
};

export const fetchDonors = params => {
	return async dispatch => {
		dispatch(getDonors());
		const path = DONORS_PATH;

		return getHandler(path, params)
			.then(json => dispatch(fetchDonorsSucceeded(json)))
			.catch(error => {
				console.error('fetchDonors error', error);
				dispatch(fetchDonorsFailed(error));
			});
	};
};

export const updateDonor = () => ({
	type: UPDATE_DONOR,
});

export const requestUpdateDonorFailed = payload => ({
	type: UPDATE_DONOR_FAILED,
	payload,
});

export const requestUpdateDonorSucceeded = payload => ({
	type: UPDATE_DONOR_SUCCEEDED,
	payload,
});

export const requestUpdateDonor = (id, body) => {
	return async (dispatch, getState) => {
		if (getPendingDonorUpdate(getState())) {
			return;
		}
		dispatch(updateDonor());
		const path = `${DONORS_PATH}/${id}`;

		return patchHandler(path, JSON.stringify(body))
			.then(json => dispatch(requestUpdateDonorSucceeded(json)))
			.catch(error => {
				console.error('requestUpdateDonor error', error);
				dispatch(requestUpdateDonorFailed(error));
			});
	};
};

export const createNewAssignment = () => ({ type: CREATE_NEW_ASSIGNMENT_REQUESTED });
export const createNewAssignmentSucceeded = (donor, fundraiser) => ({
	type: CREATE_NEW_ASSIGNMENT_SUCCEEDED,
	payload: { donor, fundraiser },
});
export const createNewAssignmentFailed = () => ({ type: CREATE_NEW_ASSIGNMENT_FAILED });

export const requestCreateNewAssignment = (fundraiser_id, donor_id) => {
	return (dispatch, getState) => {
		dispatch(createNewAssignment());

		// See WS-731. Make all fundraiser assignments created in Wisely default to primary type.
		// This is a temporary solution that should be updated once we allow
		// users to choose the type of assignment.
		const primaryType = getPrimaryFundraiserAssignmentType(getState());
		const fundraiserAssignmentTypes = primaryType ? { type: primaryType.type } : {};

		const path = 'v2/fundraiser_assignments';

		const body = JSON.stringify({
			donor_id,
			fundraiser_id,
			created_in_wisely: true,
			...fundraiserAssignmentTypes,
		});

		return postHandler(path, body)
			.then(json => dispatch(createNewAssignmentSucceeded(json.constituent, json.fundraiser)))
			.catch(error => {
				console.error('requestCreateNewAssignment error', error);
				dispatch(createNewAssignmentFailed());
			});
	};
};

export const updateAssignment = () => ({
	type: UPDATE_ASSIGNMENT_REQUESTED,
});
export const updateAssignmentSucceeded = (donor, fundraiser) => ({
	type: UPDATE_ASSIGNMENT_SUCCEEDED,
	payload: { donor, fundraiser },
});
export const updateAssignmentFailed = () => ({ type: UPDATE_ASSIGNMENT_FAILED });
export const requestUpdateAssignment = (fundraiser, constituent, body) => {
	return dispatch => {
		dispatch(updateAssignment());

		const path = 'v2/fundraiser_assignments';
		let params = { fundraiser };
		if (constituent) {
			params.constituent = constituent;
		}

		return patchHandler(path, JSON.stringify(body), params)
			.then(json => {
				/*
				Two cases here:
				- simple (un)assign, from Donor profile -> we update 'donors' state with the result of the assignment for the donor.
				- multiple unassignments + remove from team, from Team Membership -> 'donors' state contains the list
				of fundraisers, which is already updated on the removal from the team.
				 */
				if (!constituent) {
					return;
				}
				const assignment = json[0];
				dispatch(updateAssignmentSucceeded(assignment.constituent, assignment.fundraiser));
			})
			.catch(error => {
				console.error('requestUpdateAssignment error', error);
				dispatch(updateAssignmentFailed());
			});
	};
};

export const addFilter = (filterKey, value) => ({
	type: UPDATE_FILTER,
	payload: { filterKey, value },
});



// WEBPACK FOOTER //
// ./src/redux/donors/donor.action.js